import { Grid } from '@material-ui/core';
import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';


export default class ProgramCompanieZi extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
    }
    render() {
        return (
            <Grid container>
                <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                    <Grid container>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} >{this.props.ziua}:</h5>


                        </Grid>
                        <Grid style={{paddingTop:20}} item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <span>{this.dictionary.managementUtilizatori.pauza}:</span>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                    <Grid container>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Grid container>
                                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <div style={{ position: 'relative', textAlign: 'left' }}>
                                        <input
                                            style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                            id={this.props.idStart}
                                            type="time"
                                            step='any'
                                            className='add-project-input'
                                            margin="normal"
                                            name={this.props.idStart}
                                            value={this.props.valueStart || ''}
                                            onChange={this.props.changeProgram}
                                        onBlur={this.props.updateProgram}
                                        />
                                        <label className='inputLabelPM' htmlFor='telefon'>{this.dictionary.managementUtilizatori.oraIncepere}</label>
                                    </div>
                                </Grid>
                                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <div style={{ position: 'relative', textAlign: 'left' }}>
                                        <input
                                            style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                            id={this.props.idEnd}
                                            type="time"
                                            step='any'
                                            className='add-project-input'
                                            margin="normal"
                                            name={this.props.idEnd}
                                            value={this.props.valueEnd || ''}
                                            onChange={this.props.changeProgram}
                                            onBlur={this.props.updateProgram}
                                        />
                                        <label className='inputLabelPM' htmlFor='telefon'>{this.dictionary.managementUtilizatori.oraFinalizare}</label>
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid style={{paddingTop:20}} item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Grid container>
                                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <div style={{ position: 'relative', textAlign: 'left' }}>
                                        <input
                                            style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                            id={this.props.idPauzaStart}
                                            type="time"
                                            step='any'
                                            className='add-project-input'
                                            margin="normal"
                                            name={this.props.idPauzaStart}
                                            value={this.props.valuePauzaStart || ''}
                                            onChange={this.props.changeProgram}
                                            onBlur={this.props.updateProgram}
                                        />
                                        <label className='inputLabelPM' htmlFor='telefon'>{this.dictionary.managementUtilizatori.oraIncepere}</label>
                                    </div>
                                </Grid>
                                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <div style={{ position: 'relative', textAlign: 'left' }}>
                                        <input
                                            style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                            id={this.props.idPauzaEnd}
                                            type="time"
                                            step='any'
                                            className='add-project-input'
                                            margin="normal"
                                            name={this.props.idPauzaEnd}
                                            value={this.props.valuePauzaEnd || ''}
                                            onChange={this.props.changeProgram}
                                            onBlur={this.props.updateProgram}
                                        />
                                        <label className='inputLabelPM' htmlFor='telefon'>{this.dictionary.managementUtilizatori.oraFinalizare}</label>
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                </Grid>
            </Grid>
        );
    }
}